<template>
  <el-dialog
    append-to-body
    :visible.sync="visible"
    v-if="visible"
    width="80%"
    top="4vh"
    center
    class="Dialog"
    title="费用调整"
  >
    <div class="dialog-content">
      <SiruiSearch
        ref="AdjustmentCostsDialog"
        :query="query"
        :isQueryPanel="false"
        :columns="searchFormColumns"
        :rules="tableRules"
        labelWidth="160px"
      ></SiruiSearch>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" style="margin-top: 15px" @click="visible = false">取消</el-button>
        <el-button type="primary" style="margin-top: 15px" @click="chooseAdjustmentHandlerg"
          >确定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { searchColumns, tableRules } from './index.js';
  // , tableList

  export default {
    props: {},
    data() {
      return {
        load: false,

        query: {
          adjustStatementQuantity: '',
          adjustOriginalPrice: '',
          adjustOriginalAmount: '',
          adjustReason: '',
        },
        tableRules,
        visible: false,
      };
    },
    computed: {
      searchFormColumns() {
        return searchColumns();
      },
    },
    watch: {},
    mounted() {},
    methods: {
      openDialog() {
        this.visible = true;
      },
      changeMethod({ val, prop }) {
        if (prop == 'adjustStatementQuantity') {
          if (this.query.adjustOriginalAmount && this.query.adjustOriginalPrice) {
            this.query.adjustOriginalAmount = '';
            this.query.adjustOriginalPrice = '';
            return;
          }
          if (this.query.adjustOriginalAmount) {
            this.query.adjustOriginalPrice = val
              ? this.$cal.calCommon(this.query.adjustOriginalAmount, val, '/', 'amount')
              : 0;
          } else if (this.query.adjustOriginalPrice) {
            this.query.adjustOriginalAmount = (val * this.query.adjustOriginalPrice).toFixed(2);
          }
        } else if (prop == 'adjustOriginalPrice') {
          if (this.query.adjustOriginalAmount && this.query.adjustStatementQuantity) {
            this.query.adjustOriginalAmount = '';
            this.query.adjustStatementQuantity = '';
            return;
          }
          if (this.query.adjustOriginalAmount) {
            this.query.adjustOriginalPrice = val
              ? this.$cal.calCommon(this.query.adjustOriginalAmount, val, '/', 'amount')
              : 0;
          } else if (this.query.adjustStatementQuantity) {
            this.query.adjustOriginalAmount = (val * this.query.adjustStatementQuantity).toFixed(2);
          }
        } else if (prop == 'adjustOriginalAmount') {
          if (this.query.adjustOriginalPrice && this.query.adjustStatementQuantity) {
            this.query.adjustOriginalPrice = '';
            this.query.adjustStatementQuantity = '';
            return;
          }
          if (this.query.adjustOriginalPrice) {
            this.query.adjustStatementQuantity = this.$cal.calCommon(
              val,
              this.query.adjustOriginalPrice,
              '/',
              'amount'
            );
          } else if (this.query.adjustStatementQuantity) {
            this.query.adjustOriginalPrice = this.$cal.calCommon(
              val,
              this.query.adjustStatementQuantity,
              '/',
              'amount'
            );
          }
        }
      },
      //确认关联
      chooseAdjustmentHandlerg() {
        this.$refs.AdjustmentCostsDialog.validate(async (valid, baseInfoData) => {
          if (!valid) {
            this.$message.error('请检查填写信息');
            return;
          }

          console.log(baseInfoData, 'baseInfoData');

          this.$emit('chooseAdjustmentHandlerg', baseInfoData);
          this.visible = false;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 5px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 25px;
      padding: 10px;
      border-bottom: 2px solid #ddd;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  ::v-deep {
    .el-dialog__body {
      padding: 15px 20px !important;
    }
    // .el-form-item__label {
    //   width: 150px !important;
    // }
    // .el-form-item__content {
    //   margin-left: 150px !important;
    // }
  }
</style>
